module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title-heading"
  }, [_vm._v("Fly Polls")]), _vm._v(" "), (_vm.generated) ? _c('div', [_c('header', {
    staticClass: "menu-heading"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Generated Poll")]), _vm._v(" "), _c('copy', {
    attrs: {
      "text": _vm.markdown
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "preview-box",
    domProps: {
      "innerHTML": _vm._s(_vm.preview)
    }
  }), _vm._v(" "), _c('alert', {
    ref: "alert"
  })], 1) : _c('div', [_c('header', {
    staticClass: "menu-heading"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Poll Options")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumVotes),
      expression: "maximumVotes"
    }],
    attrs: {
      "name": "maximumVotes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maximumVotes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barColor),
      expression: "barColor"
    }],
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "type": "color",
      "value": "#49aaff"
    },
    domProps: {
      "value": (_vm.barColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barColor = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "115px"
    }
  }, [_c('span', [_vm._v("width:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.width),
      expression: "width"
    }],
    staticClass: "bar-width form-input",
    attrs: {
      "type": "number",
      "name": "width",
      "min": "450"
    },
    domProps: {
      "value": (_vm.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.width = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-box"
  }, [_c('draggable', {
    staticClass: "inner",
    attrs: {
      "options": {
        group: 'options',
        handle: '.handle'
      }
    },
    model: {
      value: (_vm.options),
      callback: function($$v) {
        _vm.options = $$v
      },
      expression: "options"
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: option,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "handle",
      attrs: {
        "title": "Drag item around to sort"
      }
    }, [_c('icon', {
      attrs: {
        "name": "ellipsis-v"
      }
    })], 1), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.text),
        expression: "option.text"
      }],
      ref: "options",
      refInFor: true,
      class: {
        'form-input': true, '-danger': _vm.errors[option.id]
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter option..."
      },
      domProps: {
        "value": (option.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          option.text = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "remove",
      attrs: {
        "type": "button",
        "title": "Remove this option",
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          _vm.rm(index)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "remove"
      }
    })], 1)])
  })), _vm._v(" "), _c('button', {
    ref: "add",
    staticClass: "add",
    attrs: {
      "type": "button"
    },
    on: {
      "focus": _vm.trigger,
      "click": _vm.add
    }
  }, [_vm._v("\n        Add another option\n      ")])], 1), _vm._v(" "), _c('alert', {
    ref: "alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "generate-action"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.generate
    }
  }, [(_vm.loading) ? _c('loader') : _c('span', [_vm._v("Generate")])], 1)])], 1), _vm._v(" "), _c('ui-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cbb0c6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 265
// module chunks = 1